import * as React from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react";

import { WBSStore } from "modules/WBS/WBSStore";
import TaskTable from "modules/WBS/components/layouts/TaskTable";
import TaskHeader from "modules/WBS/components/layouts/TaskHeader";
import { ToolbarTaskStore } from "modules/WBS/ToolbarTaskStore";

import { Typography, IconButton, withStyles } from "@material-ui/core";
import ArrowBack from "@material-ui/icons/ArrowBack";
import { ERowType } from "common/enums";

const styles = (theme) => ({
  gridContainer: {
    position: "absolute" as any,
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    display: "grid",
    gridTemplateRows: "120px 1fr",
    backgroundColor: "#FFFFFF",
  },
  mainBar: {
    backgroundColor: "#FFFFFF",
    display: "flex",
    alignItems: "flex-start",
    paddingRight: "15px",
    overflowX: "hidden" as any,
    overflowY: "auto" as any,
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F6F6F6",
    height: "60px",
    minWidth: "60px",
  },
  link: {
    borderRadius: "24px",
  },
  swipeableViews: {
    backgroundColor: "#FFFFFF",
  },
  tableStageLine: {
    fontWeight: 700,
    "& input": {
      fontWeight: 700,
    },
    "& td": {
      fontWeight: 700,
    },
  },
  tableFirstStageLine: {
    textTransform: "uppercase" as any,
    "& input": {
      textTransform: "uppercase" as any,
    },
    "& td": {
      textTransform: "uppercase" as any,
    },
  },
});

function TabContainer({ children }) {
  return <Typography component="div">{children}</Typography>;
}

TabContainer.propTypes = {
  children: React.Children,
};

type IProps = {
  classes: any;
};

@observer
class TaskLayer extends React.Component<IProps> {
  handleWBSTableChange = async (line, index, ref, clmn, newValue) => {
    await WBSStore.handleWBSTableChangeTask(line, index, ref, clmn, newValue);
  };
  render() {
    const { classes } = this.props,
      task = WBSStore.task,
      {
        WBS: {
          data: { decimalPlaces },
        },
      } = WBSStore;

    if (task == false) return <></>;

    let prev = location.pathname.split("/").slice(0, -1).join("/");
    let display: any = !WBSStore.shouldUpdate ? "hidden" : "visible";

    return (
      <div style={{ visibility: WBSStore.displayCostPlan }}>
        <div className={classes.gridContainer}>
          <React.Fragment>
            <div className={classes.mainBar} key={task.id}>
              <div className={classes.backButton}>
                <Link
                  className={classes.link}
                  to={prev}
                  onClick={() => {
                    ToolbarTaskStore.resetStore();
                    setTimeout(() => {
                      WBSStore.setSelectedLine(
                        WBSStore.getLineIndex,
                        "description",
                        false
                      );
                    }, 1);
                  }}
                >
                  <IconButton>
                    <ArrowBack />
                  </IconButton>
                </Link>
              </div>
              <TaskHeader
                task={{
                  ...task.data,
                  quantity: WBSStore.getCurrentTaskAccumulatedQuantity(),
                }}
              />
            </div>
            <div
              style={{
                visibility:
                  display == "visible" ? WBSStore.displayCostPlan : "hidden",
              }}
            >
              <TaskTable
                columns={[
                  {
                    label: "Código",
                    dataKey: "rowCode",
                    ref: "rowCode",
                    align: "right",
                    width: "9%",
                  },
                  {
                    label: "Descrição",
                    dataKey: "description",
                    ref: "content",
                    width: "55.47%",
                  },
                  {
                    label: "Coeficiente",
                    dataKey: "quantity",
                    ref: "row",
                    align: "center",
                    width: "6.53%",
                    numeric: { decimalScale: 8 },
                  },
                  {
                    label: "Quantidade",
                    dataKey: "calculateQuantity",
                    ref: "row",
                    align: "center",
                    width: "6.53%",
                    numeric: { decimalScale: 8 },
                  },
                  {
                    label: "Unidade",
                    dataKey: "unit",
                    ref: "content",
                    align: "center",
                    width: "7.14%",
                  },
                  {
                    label: "Custo Unit. (R$)",
                    dataKey: "unitCost",
                    ref: "content",
                    align: "right",
                    width: "7.39%",
                    numeric: {
                      decimalScale: decimalPlaces,
                      fixedDecimalScale: true,
                    },
                    link: {
                      condition: (line) => line.data.rowType === ERowType.TASK,
                      url: (line) => location.pathname + "/" + line.id,
                    },
                  },
                  {
                    label: "Total Unit. (R$)",
                    paddingRight: "10px",
                    dataKey: "total",
                    ref: "row",
                    disabled: true,
                    align: "right",
                    width: "6.90%",
                    numeric: {
                      decimalScale: 2,
                      fixedDecimalScale: true,
                    },
                  },
                ]}
                onChange={this.handleWBSTableChange}
              />
            </div>
          </React.Fragment>
        </div>
      </div>
    );
  }
}
export default withStyles(styles)(TaskLayer);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/pages/TaskLayer.tsx